'use stric'

const sortCarsTypes = [
  {
    title: 'Номер',
    type: 'number',
  },
  {
    title: 'Наименование',
    type: 'title',
  },
  {
    title: 'Регистрационный номер',
    type: 'registerNumber',
  },
  {
    title: 'Последняя активность',
    type: 'lastActive',
  },
]

const getSortCarsTypeTitle = (type) => {
  return sortCarsTypes.filter((item) => item.type === type)[0].title
}

export {
  sortCarsTypes,
  getSortCarsTypeTitle
}